import logoLight from "@/assets/logo/logo.svg";
import logoDark from "@/assets/logo/logo-white.svg";
import baiviLogo from "@/assets/baivi/icon-lg_128x128.png";

const WHITE_LABEL = import.meta.env.VITE_WHITE_LABEL as string | undefined;

interface BrandLogoProps {
  /** "light" = dark text/logo on light bg; "dark" = white text/logo on dark bg */
  variant?: "light" | "dark";
  imgClassName?: string;
  className?: string;
}

export function BrandLogo({ variant = "light", imgClassName }: BrandLogoProps) {
  if (WHITE_LABEL) {
    return <img src={baiviLogo} alt={WHITE_LABEL} className={imgClassName} />;
  }

  return (
    <img
      src={variant === "dark" ? logoDark : logoLight}
      alt="PipeTalent AI"
      className={imgClassName}
    />
  );
}
